import React from 'react';

interface Icon3DInnovationProps {
  size?: string;
}

const Icon3DInnovation: React.FC<Icon3DInnovationProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'glow-pulse 2.5s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(217, 119, 6, 0.4))' }}>
          <defs>
            <linearGradient id="innovationGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#d97706" />
              <stop offset="50%" stopColor="#f59e0b" />
              <stop offset="100%" stopColor="#b45309" />
            </linearGradient>
          </defs>
          <path d="M12 2C12 2 9 7 9 10c0 1.66 1.34 3 3 3s3-1.34 3-3c0-3-3-8-3-8z" fill="url(#innovationGradient)" opacity="0.3" />
          <path d="M12 2C12 2 9 7 9 10c0 1.66 1.34 3 3 3s3-1.34 3-3c0-3-3-8-3-8z" stroke="url(#innovationGradient)" strokeWidth="1" />
          <rect x="8" y="14" width="8" height="2" rx="1" fill="url(#innovationGradient)" />
          <circle cx="10" cy="18" r="1" fill="url(#innovationGradient)" opacity="0.6" />
          <circle cx="14" cy="18" r="1" fill="url(#innovationGradient)" opacity="0.6" />
          <circle cx="12" cy="4" r="1.5" fill="url(#innovationGradient)" opacity="0.8" />
        </svg>
        <style>{`
          @keyframes glow-pulse {
            0%, 100% { transform: scale(1) rotateZ(0deg); }
            50% { transform: scale(1.12) rotateZ(8deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DInnovation;
